export const applicationConstants = {
  TOGGLE_SIDEBAR_OFF: 'TOGGLE_SIDEBAR_OFF',
  TOGGLE_SIDEBAR_ON: 'TOGGLE_SIDEBAR_ON',

  LOADING_ON: 'LOADING_ON',
  LOADING_OFF: 'LOADING_OFF',

  TOGGLE_SIDEBAR_INTRANET_ON: 'TOGGLE_SIDEBAR_INTRANET_ON',
  TOGGLE_SIDEBAR_ADMIN_ON: 'TOGGLE_SIDEBAR_ADMIN_ON',
}
